import React from 'react';

import circleimg2 from '../imgs/circleim21.jpg';
import video1 from '../imgs/video.mp4';
import video2 from '../imgs/video.webm';
import stry from '../imgs/storyimg1.jpg';



const Section = () => {
    return (
        <section className='section-stories' id='section-stories'>
            <div className='bg-video'> 
                <video className='bg-video__content' autoPlay muted loop>
                <source src={video1} type='video/mp4'/>
                <source src={video2} type='video/webm'/>
                Your browser is not supported
                </video>
</div>

              <div  className='u-center-text u-margin-bottom-big'>
                  <h2 className='heading-secondary'>
                      We make people genuinely happy
                  </h2>
                  
            </div>
            {/* <div className='c12'><img src={c12}/> */}
                {/* <img src={c13}/></div> */}
                  <div className='row'>
                    <div className='story'>
                        <figure className='story__shape'>
                            
                                <img src={stry} alt='person on a tour' className='story__imgsbox'/>
            
                            <figcaption className='story__caption'>Harshvi Phull</figcaption>
                        </figure>
                        <div className='story__text'>
                            <h3 className='heading-tertiary u-margin-bottom-small'> I can't think of anywhere I'd rather be</h3>
                            <p>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex officia praesentium alias explicabo facere. Minus consectetur corporis cumque perferendis nesciunt tempora magnam maiores totam labore optio eligendi quos, delectus repudiandae.
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam quam dolor, quae voluptatum. Quis iusto culpa vel. 
                            </p>
                        </div>
                        <div className='wave1'>
                    <svg className='waves' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill='#F3F4F5' fillOpacity="1" d="M0,32L48,58.7C96,85,192,139,288,176C384,213,480,235,576,229.3C672,224,768,192,864,149.3C960,107,1056,53,1152,64C1248,75,1344,149,1392,186.7L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
                    </div>
                    </div>


                      </div> 
                      <div className='row'>
                    <div className='story'>
                        <figure className='story__shape'>
                            
                                <img src={circleimg2} alt='person on a tour' className='story__imgsbox'/>
            
                            <figcaption className='story__caption'>Zaid Shaikh</figcaption>
                        </figure>
                        <div className='story__text'>
                            <h3 className='heading-tertiary u-margin-bottom-small'>A Trip to remember for life!</h3>
                            <p>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex officia praesentium alias explicabo facere. Minus consectetur corporis cumque perferendis nesciunt tempora magnam maiores totam labore optio eligendi quos, delectus repudiandae.
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam quam dolor, quae voluptatum. Quis iusto culpa vel. 
                            </p>
                        </div>
                        <div className='wave2'>
    

                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
  <path fill="#F3F4F5" fillOpacity="1" d="M0,160L40,176C80,192,160,224,240,250.7C320,277,400,299,480,282.7C560,267,640,213,720,192C800,171,880,181,960,197.3C1040,213,1120,235,1200,218.7C1280,203,1360,149,1400,122.7L1440,96L1440,0L1400,0C1360,0,1280,0,1200,0C1120,0,1040,0,960,0C880,0,800,0,720,0C640,0,560,0,480,0C400,0,320,0,240,0C160,0,80,0,40,0L0,0Z"></path>
</svg>
                    
                    
                       
                        </div>
                    </div>

                      </div>

                      <div className='u-center-text u-margin-top-huge'>

<a href='#ReadAllStories' className='btn-text'>Read all stories</a>

</div>
        </section>

         
    )
}

export default Section
